import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function startRecordingSession(responseUuid, screenEnabled, cameraEnabled) {
    return axios.post(`${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/start`, {
        screen_recording_enabled: screenEnabled,
        camera_recording_enabled: cameraEnabled,
    });
}

export function completeRecordingSession(responseUuid, sessionUuid) {
    return axios.post(`${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/complete`);
}

// Persists the WebGazer calibration outcome (status/error/attempts) onto the session.
export function updateRecordingSession(responseUuid, sessionUuid, data) {
    return axios.patch(
        `${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}`,
        data
    );
}

export function startQuestionSegment(responseUuid, sessionUuid, questionUuid, questionOrder) {
    return axios.post(`${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/segments`, {
        question_uuid: questionUuid,
        question_order: questionOrder,
    });
}

export function updateQuestionSegment(responseUuid, sessionUuid, segmentUuid, data) {
    return axios.patch(
        `${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/segments/${segmentUuid}`,
        data
    );
}

export function uploadScreenRecording(responseUuid, sessionUuid, segmentUuid, formData) {
    return axios.post(
        `${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/segments/${segmentUuid}/screen`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
}

export function uploadPersonRecording(responseUuid, sessionUuid, segmentUuid, formData) {
    return axios.post(
        `${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/segments/${segmentUuid}/person`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
}

export function uploadScreenshot(responseUuid, sessionUuid, segmentUuid, formData) {
    return axios.post(
        `${BASE_URL}/public/questionnaires/responses/${responseUuid}/recording/${sessionUuid}/segments/${segmentUuid}/screenshot`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
}
